import { connect } from "react-redux";
import Header from "../../layout/Header";
import history from "../../routes/history";
import { disconnectUser, openLogin } from "../../modules/user/actions";

function pushToRoot() {
  history.push("/");
  return { type: "" };
}

export default connect(
  (state) => ({
    isAuthenticated: state.user.isAuthenticated,
    userInformations: state.user.informations,
    loginModalIsOpen: state.user.loginModalIsOpen,
    localConfigurator: state.configurator.localConfigurator,
  }),
  (dispatch) => ({
    openLoginModal: () => {
      dispatch(openLogin());
    },
    disconnectUser: () => {
      dispatch(disconnectUser());
      dispatch(pushToRoot());
    },
  }),
)(Header);
